import { isAppleIOS } from './devices.util';

// Waits for the browser to complete a full paint cycle (two animation frames),
// ensuring layout dimensions are finalized.
// Supported since iOS 6 (2012) — safe for all target devices.
export const afterNextPaint = (): Promise<void> =>
  new Promise((resolve) =>
    requestAnimationFrame(() => requestAnimationFrame(() => resolve())));

export const getScreenSize = (): { width: number; height: number; } => {
  if (isAppleIOS()) {
    return {
      // Screen width is the same as longer side of page (100vh in portrait, 100vw in landscape)
      width: Math.max(document.documentElement.scrollWidth, document.documentElement.scrollHeight),
      // Screen height is window.screen shorter side
      height: Math.min(window.screen.width, window.screen.height)
    };
  }

  // Android: use document.documentElement.scrollWidth (page size) always to match 100vh and 100vw
  return {
    width: Math.max(document.documentElement.scrollWidth, document.documentElement.scrollHeight),
    // Screen height is window.screen shorter side
    height: Math.min(document.documentElement.scrollWidth, document.documentElement.scrollHeight)
  };
};

export const isScreenPortrait = (): boolean => {
  // Prefer matchMedia — queries the CSS layout engine directly,
  // more reliable than screen.orientation.angle which can report stale values
  // (e.g. Chrome on iOS returning 0 after resuming from native camera app).
  // Supported since iOS 5 / Android 3.0.
  if (window.matchMedia) {
    return window.matchMedia('(orientation: portrait)').matches;
  }

  // Fallback for very old devices without matchMedia
  const angle = (window.screen && window.screen.orientation && window.screen.orientation.angle) || window.orientation;
  const landscape = [90, 270, -90].includes(angle);
  return !landscape;
};
